import React from "react";
import Card from "components/card";
import { 
    LuSparkles,
} from "react-icons/lu"
import ActivityCard from "./ActivityCard";

const HyvidPoints = () => {
    return (
        <Card className="flex flex-col gap-6 rounded-2xl border border-purple-200 dark:border-purple-900/50">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6">
                <h4 className="leading-none flex items-center gap-2">
                    <LuSparkles className="w-5 h-5 text-purple-600" />
                    Hyvid Points
                </h4>
                <p className="text-slate-700">
                    Your Hyvid Rewards program
                </p>
            </div>
            <div className="px-6 pb-6">
                <div className="space-y-6">
                    <div className="flex flex-col gap-6 rounded-2xl border-2 border-purple-300 dark:border-purple-700 bg-gradient-to-br from-purple-100 to-pink-100 dark:from-purple-950/50 dark:to-pink-950/50">
                        <div className="p-6 text-center">
                            <LuSparkles className="w-12 h-12 mx-auto mb-3 text-purple-600 dark:text-purple-400"/>
                            <p className="text-sm text-slate-700 mb-2">Your Balance</p>
                            <p className="text-4xl font-bold text-purple-600 mb-2">2,450</p>
                            <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 transition-[color,box-shadow] overflow-hidden border-transparent bg-purple-600 text-white">
                                Top 15% Rank
                            </span>
                        </div>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-3">
                            Recent Activity
                        </h4>
                        <div className="space-y-2">
                            <ActivityCard 
                                title="Completed Training Module"
                                date="Oct 20"
                                points="+50"
                            />
                            <ActivityCard 
                                title="Innovation Award"
                                date="Oct 15"
                                points="+200"
                            />
                            <ActivityCard 
                                title="Perfect Attendance (Sep)"
                                date="Oct 1"
                                points="+100"
                            />
                            <ActivityCard 
                                title="Peer Recognition"
                                date="Sep 28"
                                points="+25"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
};
export default HyvidPoints;